import customAxios from "./axiosConfig";

const UserRightsService = {
  retrieveCurrent (params){
    const api_url = window.Urls['userrights_current_user_rights']()
    return customAxios.get(api_url,  { params: params })
  },
  retrieve (pk) {
    const api_url = window.Urls['userrights-detail'](pk)
    return customAxios.get(api_url);
  },
  create (data) {
    const api_url = window.Urls['userrights-list']()
    return customAxios.post(api_url, data);
  },
  update (data) {
    const api_url = window.Urls['userrights-detail'](data.id)
    return customAxios.put(api_url, data);
  },
  destroy (pk) {
    const api_url = window.Urls['userrights-detail'](pk)
    return customAxios.delete(api_url);
  },

};

export default UserRightsService;

